import { Component } from '@angular/core';
import { AbstractWidgetComponent } from '../../shared/abstract-widget.component';

@Component({
    selector: 'app-device-overview-widget',
    imports: [],
    templateUrl: './device-overview-widget.component.html',
    styleUrl: './device-overview-widget.component.scss'
})
export class DeviceOverviewWidgetComponent extends AbstractWidgetComponent {
  public override defaultSizeX: number = 3;
  public override defaultSizeY: number = 2;

  private panelId: string;
  private onDeleteCallback: (panelId: string) => void;

  public override initializeParameters(panelId: string, serializedParameters: string, onDeleteCallback: (panelId: string) => void) {
    this.panelId = panelId;
    this.onDeleteCallback = onDeleteCallback;
  }
}
